import { AVAILABLE_LANGUAGES } from '$ops-portal/locale/constants';
import type { OPS_ROLES } from '@dfg/brahma-types';

export const DASHBOARD_URLS = {
  dashboard: `/dashboard/my-dashboard`,
  finance: `/dashboard/finance`,
  createRefundPayout: `/dashboard/finance/adhoc-requests`,
  createClient: '/dashboard/client/create-client',
  validation: `/dashboard/validation`,
  insufficiencySupport: `/dashboard/insufficiency-support`,
  verification: `/dashboard/verification`,
  verificationQC: `/dashboard/verification-qc`,
  reportQC: `/dashboard/report-qc`,
  documentTranslation: `/dashboard/document-translation`,
  teamMembers: `/dashboard/team-members`,
  createTeamMember: `/dashboard/team-members/create-members`,
  editMember: `/dashboard/team-members/edit-member`,
  addVendor: '/dashboard/add-vendor',
  editVendor: '/dashboard/edit-vendor?vendorId=#{vendorId}',
  dashboardVendor: '/dashboard/vendor-dashboard',
  addAccreditation: '/dashboard/add-accreditation',
  accreditationDatabase: '/dashboard/accreditation-database',
  editAccreditation:
    '/dashboard/add-accreditation?accreditationId=#{accreditationId}',
  vendorDetails: '/dashboard/vendor-details?vendorId=#{vendorId}',
  iaAccreditation: '/dashboard/ia-accreditation',
  iaAccreditaionApproval: '/dashboard/ia-accreditation-approval',
  iaCreation: '/dashboard/ia-creation',
  iaApproval: '/dashboard/ia-approval',
  iaResearch: '/dashboard/ia-research',
  iaVendorMapping: '/dashboard/ia-vendor-mapping',
  partnerDashboard: '/dashboard/partner',
  createPartner: '/dashboard/partner/create-partner',
  reviewTasks: '/dashboard/review-tasks',
  iaPayout: '/dashboard/finance/ia-payout?caseId=#{caseId}',
  refundPayout: '/dashboard/finance/refund-payout?caseId=#{caseId}',
  financeDashboad: '/dashboard/finance',
  clientDashboard: '/dashboard/client',
  auditDashboard: '/dashboard/audit',
  applicantSupportDashboard: '/dashboard/support',
  taskAllocation: '/dashboard/task-allocation',
  financeDashboard: '/dashboard/finance',
  opsPerformance: '/dashboard/ops-performance',
  teamPerformance: '/dashboard/team-performance',
  individualPerformance: '/dashboard/individual-performance',
  insight: '/dashboard/insight',
  verificationDetails: `/dashboard/verification/verification-details?caseId=#{caseId}`,
  auditVerificationDetails: `/dashboard/audit/verification/verification-details?caseId=#{caseId}&claimId=#{claimId}`,
  siteVerificationDashboard: '/dashboard/site-verification',
  financeAnalyticsDashboard: '/dashboard/finance-dashboard',
  partnerDetails: '/dashboard/partner/partner-details?partnerId=#{partnerId}',
  clientDetails: '/dashboard/client/client-details?clientId=#{clientId}',
  clientContractDashboard: '/dashboard/client-contract',
  clientContractDetails:
    '/dashboard/client-contract/client-contract-details?clientId=#{clientId}',
  caseCreationEntry: '/dashboard/case-creation-entry',
  clientContractAllDetails:
    '/dashboard/client-contract/client-contract-details/client-contract-all-details?clientContractId=#{clientContractId}&clientId=#{clientId}',
  editClient: '/dashboard/client/edit?clientId=#{clientId}',
  editPartner: '/dashboard/partner/edit?partnerId=#{partnerId}',
  trackCases: '/dashboard/track-cases',
  reviewTask: '/dashboard/review-task',
  pendingClaims: '/dashboard/pending-claims',
  pendingInsufficiencies: '/dashboard/pending-insufficiencies',
  vendorTask: '/dashboard/vendor-task',
  dataTamperingAnalysis: '/dashboard/data-tampering-analysis',
  forceMajeure: '/dashboard/force-majeure',
  kvPairConfig: '/dashboard/kv-pair-config',
  verificationManager: '/dashboard/verification-manager',
  iaPerformance: '/dashboard/ia-performance',
  reportApproval: '/dashboard/report-approval',
  reportApprovalDetail: '/approval?caseId=#{caseId}',
  iaResearchDashboard: '/dashboard/ia-research-dashboard',
  productAnomalyDashboard: '/dashboard/product-anomaly-dashboard',
  misReport: '/dashboard/mis-report',
  financeLedger: '/dashboard/finance-ledger',
  gci: '/dashboard/gci'
};

export const SEARCH_PARAMS_KEYS = {
  ssoLoginCode: 'code',
  accreditationId: 'accreditationId',
  caseId: 'caseId',
  activeClaimItemId: 'activeClaimItemId',
  issuingAuthorityId: 'issuingAuthorityId',
  siteProofId: 'siteProofId',
  partnerId: 'partnerId',
  vendorId: 'vendorId',
  manager: 'manager',
  claimCaseId: 'claimCaseId',
  clientId: 'clientId',
  iaId: 'iaId',
  officeId: 'officeId',
  activeTab: 'activeTab',
  verificationId: 'verificationId',
  verificationRequestId: 'verificationRequestId',
  applicantUserId: 'applicantUserId',
  componentId: 'componentId',
  claimId: 'claimId',
  clientContractId: 'clientContractId',
  applicantId: 'applicantId',
  transactionID: 'transactionID',
  skipEducation: 'skipEducation',
  skipProfession: 'skipProfession',
  skipSelectComponent: 'skipSelectComponent',
  token: 'token',
  country: 'country',
  authority: 'authority',
  title: 'title',
  redirectUrl: 'redirectUrl',
  source: 'source',
  categoryId: 'categoryId',
  purposeId: 'purposeId',
  purposeCategoryId: 'purposeCategoryId',
  orderId: 'orderId',
  redirect: 'redirect',
  adId: 'adId',
  code: 'code',
  uaePassState: 'state',
  error: 'error',
  errorDescription: 'error_description',
  type: 'type',
  originalVerificationRequestId: 'originalVerificationRequestId',
  documentId: 'documentId',
  passportNo: 'passportNo',
  dob: 'dob',
  email: 'email',
  phoneNo: 'phoneNo',
  parentVerificationRequestId: 'parentVerificationRequestId',
  paymentTransactionId: 'paymentTransactionId',
  redirectAfterFetchReport: 'redirectAfterFetchReport',
  overlapIndex: 'overlapIndex',
  clientShortCode: 'clientShortCode',
  isDrawerOpen: 'is-drawer-open',
  isMigrationFlow: 'isMigrationFlow',
  migrationLevel: 'migrationLevel',
  range: 'range',
  from: 'from',
  to: 'to',
  screenType: 'ScreenType',
  tab: 'tab'
};

export const VERIFICATION_URLS = {
  selectCountry: '/verification/select-country',
  selectAuthority: '/verification/select-authority',
  addSpeciality: '/verification/add-speciality',
  iaAttribution: '/verification/ia-attribution',
  requiredDocuments: '/verification/required-documents',
  overviewSummary:
    '/verification/overview-summary?verificationRequestId=#{verificationRequestId}',
  overview:
    '/verification/overview?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  pricingDetailsUrl: `/verification/pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}`,
  verificationInsufficiency: `/verification/verification-insufficiency?verificationId=#{verificationId}&applicantUserId=#{applicantUserId}`,
  verificationInsufficiencyOverview: `/verification/verification-insufficiency/overview?verificationId=#{verificationId}&applicantUserId=#{applicantUserId}`,
  aboutEducation:
    '/verification/about-education?verificationRequestId=#{verificationRequestId}&skipProfession=#{skipProfession}&applicantUserId=#{applicantUserId}&skipSelectComponent=#{skipSelectComponent}',
  educationDetails:
    '/verification/education-details?verificationRequestId=#{verificationRequestId}&skipProfession=#{skipProfession}&applicantUserId=#{applicantUserId}&skipSelectComponent=#{skipSelectComponent}',
  aboutWorkEx:
    '/verification/about-workex?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&skipSelectComponent=#{skipSelectComponent}',
  workExperience:
    '/verification/work-experience?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&skipSelectComponent=#{skipSelectComponent}',
  uploadDocumentsForVerification:
    '/verification/document-upload?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  uploadDocumentsForEditComponent:
    '/verification/document-upload?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&componentId=#{componentId}',
  pricingEstimation:
    '/verification/pricing-estimate?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&componentId=#{componentId}',
  insufficiencyPricingEstimation:
    '/verification/insufficiency-pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&insufficiency=true',
  letterOfAuth: `/verification/letter-of-auth?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&isMigrationFlow=#{isMigrationFlow}`,
  VRSuccess: '/verification/vr-success',
  appealRequest:
    '/verification/appeal-request?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&caseId=#{caseId}',
  requestCorrection:
    '/verification/request-correction?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&caseId=#{caseId}',
  paymentStatus:
    '/verification/payment-status?PaymentTransactionId=#{PaymentTransactionId}&paymentStatus=#{paymentStatus}&verificationRequestId=#{verificationRequestId}',
  additionalComponents:
    '/verification/additional-components?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&parentVerificationRequestId=#{parentVerificationRequestId}',
  reportTransfer:
    '/verification/report-transfer?verificationRequestId=#{verificationRequestId}&skipEducation=#{skipEducation}&skipProfession=#{skipProfession}&applicantUserId=#{applicantUserId}&skipSelectComponent=#{skipSelectComponent}',
  nameChange:
    '/verification/name-change?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  findReport: `/verification/find-report?${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}`,
  reportDocumentDetails: `/verification/find-report/report-document-details?documentId=#{documentId}&${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}`,
  fetchReportDetails: `/verification/find-report/fetch-report-details?${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}`,
  VerifyReportDetails:
    '/verification/find-report/verify-report-details?passportNo=#{passportNo}&dob=#{dob}&email=#{email}&phoneNo=#{phoneNo}&verificationRequestId=#{verificationRequestId}',
  existingReports: `/verification/find-report/existing-reports?passportNo=#{passportNo}&dob=#{dob}&caseId=#{caseId}&${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}`,
  selectComponent:
    '/verification/select-component?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  submitApplication: `/verification/submit-application?verificationRequestId=#{verificationRequestId}`,
  fetchReportPricing:
    '/verification/fetch-report-pricing?verificationRequestId=#{verificationRequestId}',
  additionalAuthentication:
    '/verification/additional-authentication?type=#{type}&verificationRequestId=#{verificationRequestId}&error=#{error}',
  approvalSent: `/verification/approval-sent?verificationRequestId=#{verificationRequestId}`,
  addSpecialityUrl:
    '/verification/add-speciality?authority=#{authority}&country=#{country}',
  fetchReportReissuePricing:
    '/verification/reissue-report?verificationRequestId=#{verificationRequestId}'
};

export const NOTIFICATIONS_URLS = {
  home: '/notifications',
  noNotificationImgPath: '/assets/image/amico.png'
};

export const PAGE_URLS = {
  ssoLoginUrl: '/onboarding/sso-login',
  home: '/dashboard/home',
  myDashboard: '/dashboard/my-dashboard',
  validation: '/validation?caseId=#{caseId}',
  verification: '/verifier-initiation?caseId=#{caseId}',
  qualityCheck: '/quality-check?caseId=#{caseId}',
  reportReview: '/report?caseId=#{caseId}',
  documentTranslation: '/document-translation?caseId=#{caseId}',
  verificationFollowup: '/verifier-follow-up?caseId=#{caseId}',
  vendorFollowup: '/vendor-follow-up?caseId=#{caseId}',
  iaPayout: '/dashboard/finance/ia-payout?caseId=#{caseId}',
  refundPayout: '/dashboard/finance/refund-payout?caseId=#{caseId}',
  verifyBulkDetails: 'verify-details',
  iaAccreditationMapping:
    '/ia-accreditation-mapping?caseId=#{caseId}&iaAddressId=#{iaAddressId}',
  iaAccreditationApproval: '/ia-accreditation-approval?caseId=#{caseId}',
  iaCreation: '/issuing-authority-map?caseId=#{caseId}',
  iaApproval: `/ia-approval?caseId=#{caseId}&${SEARCH_PARAMS_KEYS.iaId}=#{${SEARCH_PARAMS_KEYS.iaId}}&${SEARCH_PARAMS_KEYS.officeId}=#{${SEARCH_PARAMS_KEYS.officeId}}`,
  iaVendorMapping: '/ia-vendor-mapping?caseId=#{caseId}',
  iaResearch: '/issuing-authority-map?officeId=#{issuingAuthorityOfficeId}',
  iaDetailPage: '/issuing-authority-map/#{issuingAuthorityOfficeId}',
  iaOfficeDetailPage:
    '/issuing-authority-map/#{issuingAuthorityId}/#{issuingAuthorityOfficeId}',
  insufficiencySupport: '/insufficiency-support?caseId=#{caseId}',
  insufficiencyReview: '/insufficiency-review?caseId=#{caseId}',
  caseCreationEntry:
    '/case-entry?caseId=#{caseId}&verificationRequestId=#{verificationRequestId}',
  writtenResponseFollowUp: '/written-response-follow-up?caseId=#{caseId}',
  rtInternalComponentMapping:
    '/validation/rt-internal-component-mapping?caseId=#{caseId}&migrationLevel=#{migrationLevel}',
  rtInternalFillComponents:
    '/validation/rt-internal-fill-components?caseId=#{caseId}&migrationLevel=#{migrationLevel}',
  reportApproval: '/dashboard/report-approval',
  reportApprovalDetail: '/approval?caseId=#{caseId}',
  faq: 'https://support.dataflowgroup.com/'
};

export const NON_LOGGED_IN_PAGE_URLS = [PAGE_URLS.ssoLoginUrl];

export const COUNTRY_CODE = 'countryCode';
export const COUNTRY_FLAG_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/country/#{${COUNTRY_CODE}}.svg`;
export const ROLE_MAPPING: Record<
  string,
  // TO DO: add this in brahma-types OPS_ROLES in next commit
  OPS_ROLES
> = {
  ROLE_CLAIM_VALIDATOR: 'validation',
  ROLE_INSUFFICIENCY_CREATOR: 'validation',
  ROLE_INSUFFICIENCY_VALIDATOR: 'validation',
  ROLE_APPEAL_REVIEWER: 'validation',
  ROLE_CLAIM_EDITOR: 'validation',
  ROLE_INSUFFICIENCY_FOLLOWUP_PERFORMER: 'insufficiencySupport',
  ROLE_VERIFICATION_INITIATOR: 'verification',
  ROLE_VERIFICATION_FOLLOWUP_PERFORMER: 'verification',
  ROLE_VERIFICATION_RESPONSE_UPDATE_PERFORMER: 'verification',
  ROLE_VERIFICATION_RESPONSE_VENDOR_REVIEWER: 'verification',
  ROLE_VERIFICATION_QUALITYREJECT_PERFORMER: 'verification',
  ROLE_QUALITY_CHECK_PERFORMER: 'verificationQC',
  ROLE_VENDOR_CREATOR: 'vendorCreator',
  ROLE_REPORT_PUBLISHER: 'reportQC',
  ROLE_DOCUMENT_TRANSLATOR: 'documentTranslation',
  ROLE_ADMIN: 'admin',
  ROLE_USER_CREATOR: 'admin',
  ROLE_IA_ACCREDITATION_CREATOR: 'iaAccreditor',
  ROLE_IA_ACCREDITATION_APPROVER: 'iaAccreditorApprover',
  ROLE_VENDOR_APPROVER: 'vendorManagement',
  ROLE_IA_CREATOR: 'iaCreator',
  ROLE_IA_EXISTENCE_VERIFIER: 'iaCreator',
  ROLE_IA_APPROVER: 'iaApprover',
  ROLE_REFUND_REQUEST_CREATOR: 'fincancePaymentProcessing',
  ROLE_REFUND_PAYOUT_PERFORMER: 'fincancePaymentProcessing',
  ROLE_IA_PAYOUT_PERFORMER: 'fincancePaymentProcessing',
  ROLE_PARTNER_CREATOR: 'partnerCreator',
  ROLE_CLIENT_CREATOR: 'clientCreator',
  ROLE_IA_SUSPICION_UPDATE: 'iaResearcher',
  ROLE_IA_PROACTIVE_CREATOR: 'iaResearcher',
  ROLE_ACCREDITATION_CREATOR: 'accreditationCreator',
  ROLE_AUDITOR: 'auditor',
  ROLE_APPLICANT_SUPPORT: 'applicantSupport',
  ROLE_TASK_ALLOCATOR: 'taskAllocator',
  ROLE_TRACK_CASES: 'trackCases',
  ROLE_VENDOR_MAPPING: 'iaVendorMapping',
  ROLE_VERIFICATION_TEAM_LEAD: 'verification',
  ROLE_DATA_TAMPERING_ANALYST: 'dataTamperingAnalysis',
  ROLE_FORCE_MAJEURE: 'forceMajeure',
  ROLE_CASE_CREATION_ENTRY: 'caseCreationEntry',
  ROLE_KVPAIR_CONFIG_MANAGER: 'kvPairConfig',
  ROLE_KVPAIR_CONFIG_VIEWER: 'kvPairConfig',
  ROLE_IA_PERFORMANCE_VIEWER: 'iaPerformanceViewer',
  ROLE_FINANCE_ANALYTICS: 'financeLedger',
  ROLE_REPORT_APPROVER: 'reportApproval',
  ROLE_GCI_VIEWER: 'gciViewer',
  ROLE_GCI_MANAGER: 'gciManager'
};
/** Process keys used to control visibility of individual performance overview sections */
export const INDIVIDUAL_PERFORMANCE_OVERVIEW_PROCESS = {
  VALIDATION: 'validation',
  VERIFICATION_QC: 'verificationQC',
  REPORT_QC: 'reportQC',
  IA_CREATOR: 'iaCreator',
  IA_PROACTIVE: 'iaProactive',
  IA_REACTIVE: 'iaReactive',
  REPORT_QC_REJECTION_RAISED: 'reportQCRaised',
  VERIFICATION_QC_REJECTION_RAISED: 'verificationQCRaised',
  INSUFFICIENCY_RAISED: 'insufficiencyRaised'
} as const;
export const ROLE_TO_ROLE_NAME: Record<
  // TO DO: add this in brahma-types OPS_ROLES in next commit
  OPS_ROLES,
  string
> = {
  validation: 'Validator',
  verification: 'Verification Performer',
  verificationQC: 'QC performer',
  reportQC: 'Report Viewer',
  admin: 'Admin',
  iaAccreditor: 'IA Accreditor',
  iaAccreditorApprover: 'IA Accreditor Approver',
  vendorManagement: 'Vendor',
  fincancePaymentProcessing: 'Finance Payment Processor', // TO DO: same here
  iaCreator: 'IA Creator',
  iaApprover: 'IA Approver',
  iaResearcher: 'IA Researcher',
  vendorCreator: 'Vendor Creator',
  partnerCreator: 'Partner Creator',
  clientCreator: 'Client Creator',
  accreditationCreator: 'Accreditation Creator',
  auditor: 'Auditor',
  applicantSupport: 'Applicant Support',
  insufficiencySupport: 'Insufficiency Support',
  taskAllocator: 'Task Allocator',
  trackCases: 'Track Cases',
  iaVendorMapping: 'Ia Vendor Mapping',
  documentTranslation: 'Document Translator',
  dataTamperingAnalysis: 'Data Tampering Analysis',
  forceMajeure: 'Force Majeure',
  caseCreationEntry: 'Case Creation Entry',
  kvPairConfig: 'KVPair Management',
  insightDashboard: 'Insight Dashboard',
  verificationManagerDashboard: 'Verification Manager Dashboard',
  iaPerformanceViewer: 'IA Performance',
  iaResearchDashboard: 'IA Research Dashboard',
  financeLedger: 'Finance Ledger',
  reportApproval: 'Report Approval',
  gciViewer: 'GCI Viewer',
  gciManager: 'GCI Manager'
};

export const ROLE_TO_PROCESS: Record<
  // TO DO: add this in brahma-types OPS_ROLES in next commit
  OPS_ROLES,
  string
> = {
  validation: 'Validaton',
  verification: 'Verification',
  verificationQC: 'Quality Check',
  reportQC: 'Report Review',
  admin: 'Admin',
  fincancePaymentProcessing: 'Finance',
  iaAccreditor: 'IA Accreditation',
  iaAccreditorApprover: 'IA Accreditation',
  vendorManagement: 'Vendor',
  iaCreator: 'IA Creation',
  iaApprover: 'IA Approval',
  vendorCreator: 'Vendor Mapping',
  partnerCreator: 'Partner',
  clientCreator: 'Client',
  iaResearcher: 'IA Researcher',
  accreditationCreator: 'Accrediting Database',
  auditor: 'Audit',
  applicantSupport: 'Applicant Support',
  insufficiencySupport: 'Insufficiency Support',
  taskAllocator: 'Task Allocation',
  trackCases: 'Track Cases',
  iaVendorMapping: 'Ia Vendor Mapping',
  documentTranslation: '',
  dataTamperingAnalysis: 'Data Tampering Analysis',
  forceMajeure: 'Force Majeure',
  caseCreationEntry: 'Case Creation Entry',
  kvPairConfig: 'KVPair Management',
  insightDashboard: 'Insight Dashboard',
  verificationManagerDashboard: 'Verification Manager Dashboard',
  iaPerformanceViewer: 'IA Performance',
  iaResearchDashboard: 'IA Research Dashboard',
  financeLedger: 'Finance Ledger',
  reportApproval: 'Report Approval',
  gciViewer: 'Global Corruption Index',
  gciManager: 'Global Corruption Index'
};

export const VALID_FILE_TYPES = ['PNG', 'JPG', 'PDF'];
export const VALID_REPORT_FILE_TYPES = ['PDF']; // need to confirm with ops
export const MRL_FILE_TYPES = ['png', 'jpg', 'jpeg', 'pdf'];

export const EMPTY_SCREEN_IMAGE_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/no_documents.png`;

export const webGlobalMockState = {
  screen: {
    isMobile: false
  },
  locale: {
    lang: AVAILABLE_LANGUAGES.en
  }
};

export const mobileGlobalMockState = {
  screen: {
    isMobile: true
  },
  locale: {
    lang: AVAILABLE_LANGUAGES.en
  }
};

export const SCREEN_TYPES = {
  ASSIGNED_TASKS: 'AssignedTasks',
  COMPLETED_TASKS: 'CompletedTasks',
  REJECTED_TASKS: 'RejectedTasks',
  MULTIPLE_REJECTED_TASKS: 'MultipleRejectedTasks',
  IA_PROACTIVE: 'IA_PROACTIVE',
  IA_REACTIVE: 'IA_REACTIVE',
  REPORT_QC_REJECTION_RAISED: 'REPORT_QC_REJECTION_RAISED',
  VERIFICATION_QC_REJECTION_RAISED: 'VERIFICATION_QC_REJECTION_RAISED',
  INSUFFICIENCY_RAISED: 'INSUFFICIENCY_RAISED'
};

/** CDM (Insight) dashboard detail modal: sort field keys for API. */
export const CDM_DETAIL_SORT = {
  CASES: { 'verificationRequest.expectedSlaEndTimestamp': 'asc' as const },
  CHECKS: { 'claimItem.expectedSlaEndTimestamp': 'desc' as const }
};
